import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateResponsePanel = document.createElement('template');

templateResponsePanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
  <div id="responseTitle"></div>
  <div class="right-side-response">
    <div id="lastUpdated">
    </div>
     <gz-icon-button id="refreshButton" fontsize="20" icon="ds-icon-refresh" size="24" buttontype="square" buttonfill="quiet" buttoncolor="secondary"></gz-icon-button>
   </div>

  <gz-tab-group>
    <gz-tab id="actionNeededTab"></gz-tab>
    <gz-tab id="executedTab"></gz-tab>
  </gz-tab-group>
  </div>
`;
